export { default } from './MediaTextTeaser';
